import consumer from "./consumer";

document.addEventListener("turbolinks:load", () => {
  const noticeContainer = document.querySelector("[data-process-template-id]");
  if (!noticeContainer) return;

  const processTemplateId = noticeContainer.dataset.processTemplateId;
  const percentageElement = noticeContainer.querySelector("[data-percentage-target]");
  const refreshLink = document.getElementById("auto-refresh-link");

  if (!processTemplateId || !percentageElement) return;

  consumer.subscriptions.create(
    {
      channel: "PropagationProgressChannel",
      process_template_id: processTemplateId
    },
    {
      connected() {
        console.log(`Connected to PropagationProgressChannel for template ${processTemplateId}`);
      },
      disconnected() {
        console.log("Disconnected from PropagationProgressChannel");
      },
      received(data) {
        if (data.percentage !== undefined) {
          percentageElement.textContent = `${data.percentage}% complete.`;

          // When complete, update task list and hide notice
          if (data.percentage === 100) {
            const notice = document.querySelector(".propagation-message");
            if (notice) notice.remove();

            fetch(`/accounts/${data.account_id}/process_templates/${processTemplateId}/task_lists_partial`)
              .then(response => response.text())
              .then(html => {
                const container = document.getElementById("task-list-partial");
                if (container) container.innerHTML = html;
              });
          }
        }
      }
    }
  );
});
